import React from 'react';
const PackersMovers = () => <div className="service-page"><h1>Packers & Movers</h1><p>Reliable packers and movers for safe relocation.</p></div>;
export default PackersMovers;
